import { type ComponentType, type PropsWithChildren } from "react"

type ConditionalWrapperProps = PropsWithChildren<{
    condition: boolean
    Wrapper: ComponentType<PropsWithChildren>
}>

export function ConditionalWrapper({ condition, Wrapper, children }: ConditionalWrapperProps) {
    if (condition) {
        return <Wrapper>{children}</Wrapper>
    }

    return children
}
